"use client";

import React, { FC } from "react";

import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { HeaderToolbar } from "../../header-toolbar/component";
import { SLIDE_MENU_CLASSES } from "../constants";
import { SideMenuProps } from "../types";

import { SlideMenuDrawer } from "./styled";

export const ClassicSideMenu: FC<SideMenuProps> = ({
  logo,
  isOpen,
  onClose,
  children,
}) => (
  <SlideMenuDrawer
    slotProps={{
      paper: {
        className: SLIDE_MENU_CLASSES.drawer,
        ...getTestAutomationProps("side-menu"),
      },
    }}
    anchor="left"
    open={isOpen}
    onClose={onClose}
  >
    <HeaderToolbar logo={logo} isMenuOpen onMenuOpen={onClose} />
    {children}
  </SlideMenuDrawer>
);
